<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="加水点">
              <j-search-select-tag
                @change="searchQuery"
                dict="`iwt-wf`.dev_list,dev_name,id, del_flag=0 order by sort asc"
                placeholder="请选择加水点"
                v-if=" !userInfo.thirdAccount"
                v-model="queryParam.devId"
              />

              <j-search-select-tag
                :dictOptions="devOptions"
                @change="searchQuery"
                placeholder="请选择加水点"
                v-if=" !!userInfo.thirdAccount"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col
            :lg="5"
            :md="5"
            :sm="24"
            :xl="5"
            v-if=" !userInfo.thirdAccount && !hiddenQueryItems.includes('corpId')"
          >
            <a-form-item label="用水企业">
              <j-search-select-tag
                @change="corpChange"
                dict="`iwt-wf`.wf_consumer_corp,corp_name,id, 1=1 order by corp_name asc"
                placeholder="请选择用水企业"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="6" :md="6" :sm="24" :xl="6" v-if=" userInfo.thirdAccount ">
            <a-form-item label="班组">
              <j-search-select-tag
                :dictOptions="consGroupOptions"
                @change="groupChange"
                placeholder="请选择班组"
                v-model="queryParam.groupId"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="取水人">
              <j-search-select-tag
                :dictOptions="consUserOptions"
                @change="searchQuery"
                placeholder="请选择取水人"
                v-model="queryParam.consumerUserId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="加水时间">
              <a-range-picker
                :placeholder="['起始时间', '结束时间']"
                @change="getList"
                format="YYYY-MM-DD"
                v-model="timeRange"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="状态">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="wf_record_status"
                placeholder="请选择更新方式"
                type="checkbox"
                v-model="queryParam.curStatus"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('加水记录')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        本页合计取水量
        <a style="font-weight: 600">{{ totalRealVolume.toFixed(1) }}</a>吨，
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="statusSlot" slot-scope="curStatus, record">
          <a-tag :color=" record.curStatus == 0 ? '#ff4d4f' : '#52c41a' ">{{record.curStatus_dictText}}</a-tag>
        </span>
        <span slot="valueSlot" slot-scope="realVolume, record">
          <a-tooltip :title="record.anomalyReason" v-if="record.isAnomalous">
            <div style="width: 100%; color: #fff; background-color: #ff4d4f;">{{realVolume}}</div>
          </a-tooltip>
          <span v-else>{{realVolume}}</span>
        </span>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <template v-if="!record.isFrozen">
            <a @click="editRecord(record)">修正</a>
            <a-divider type="vertical" />
            <a @click="addRecord(record)">补录</a>
            <a-divider type="vertical" />
            <a-popconfirm
              :title="record.realVolume > 0 ? '确定删除吗?本记录实际加水量不为0' : '确定删除吗?'"
              @confirm="() => handleDelete(record.id)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
          <template v-else>
            <span style="color: #999;">已冻结</span>
          </template>
        </span>
      </a-table>
    </div>

    <wf-consumer-record-modal @ok="modalFormOk" ref="modalForm"></wf-consumer-record-modal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfConsumerRecordModal from './modules/WfConsumerRecordModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import dayjs from 'dayjs'

  export default {
    name: 'WfConsumerRecordRepair',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfConsumerRecordModal
    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    watch: {
      filter: {
        handler () {
          this.searchQuery();
        },
        deep: true
      }
    },
    data () {
      return {
        description: '加水记录管理页面',
        timeRange: [],
        isorter: {
          column: 'startTime',
          order: 'desc',
        },
        ipagination: {
          pageSize: 100,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '设备',
            align: "center",
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title: '用水企业',
            align: "center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title: '取水人',
            align: "center",
            sorter: true,
            dataIndex: 'consumerUserId_dictText'
          },
          {
            title: '计划取水量',
            align: "center",
            sorter: true,
            dataIndex: 'planVolume'
          },
          {
            title: '实际取水量',
            align: "center",
            sorter: true,
            dataIndex: 'realVolume',
            scopedSlots: { customRender: 'valueSlot' }
          },
          {
            title: '起码',
            align: "center",
            sorter: true,
            dataIndex: 'startVal'
          },
          {
            title: '止码',
            align: "center",
            sorter: true,
            dataIndex: 'endVal'
          },
          {
            title: '状态',
            align: "center",
            sorter: true,
            dataIndex: 'curStatus',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '开始时间',
            align: "center",
            sorter: true,
            dataIndex: 'startTime'
          },
          {
            title: '结束时间',
            align: "center",
            sorter: true,
            dataIndex: 'endTime'
          },
          {
            title: '结束原因',
            align: "center",
            sorter: true,
            dataIndex: 'endReason_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 160,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/wfConsumerRecord/list",
          delete: "/wf/wfConsumerRecord/delete",
          deleteBatch: "/wf/wfConsumerRecord/deleteBatch",
          exportXlsUrl: "/wf/wfConsumerRecord/exportXls",
          importExcelUrl: "wf/wfConsumerRecord/importExcel",
          corpDevList: 'device/devList/corpList',
          corpGroupList: 'wf/corpGroup/list',
          corpUserList: "/custom/user/list",
          categoryList: "/custom/category/list"
        },
        localFilter: {},
        dictOptions: {},
        devOptions: [],
        consUserOptions: [],

        consGroupOptions: [],
        superFieldList: [],
        disableMixinCreated: true,
        // 添加冻结相关配置变量
        freezeDeadline: -1, // 数据冻结修改期限
        freezeDay: 1, // 月报冻结日
      }
    },
    created () {
      this.getSuperFieldList();
      this.getFeezeConfig();
      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if (!!this.userInfo.thirdAccount) {
        this.localFilter = {
          corpId: this.userInfo.corpIds
        }
        this.getDevList();
      }

      if (this.filter?.corpId || this.localFilter?.corpId) {
        this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
        //写入queryParam，查询和导出都增加过滤条件
        this.queryParam.corpId = this.queryParam.corpId = this.filter?.corpId || this.localFilter?.corpId;
      }

      // 在 localFilter 设置完成后调用 loadData
      this.$nextTick(() => {
        this.loadData(1);
      });

      this.getConsGroup();
      this.getConsUser();
    },
    computed: {
      importExcelUrl () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      totalRealVolume () {
        return this.dataSource.reduce((total, current) => total + current.realVolume * 1000, 0) / 1000
      },
      hiddenQueryItems () {
        return this.filter ? Object.keys(this.filter) : [];
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      // 检查冻结日是否有效
      checkFreezeDayValid () {
        return this.freezeDay >= 1 && this.freezeDay <= 31;
      },
      // 检查记录是否在冻结期内
      checkFreezePeriod (recordDate) {
        if (this.freezeDeadline < 0 || !this.checkFreezeDayValid()) {
          return true; // 如果未配置冻结期限或冻结日无效，允许修改
        }

        const today = dayjs().startOf('day'); // 忽略时分秒
        const date = dayjs(recordDate).startOf('day'); // 忽略时分秒

        // 获取本月的结算日（如10号）
        const currentMonthFreezeDay = dayjs().startOf('day').date(this.freezeDay);

        // 计算本月的冻结截止日（结算日+冻结期限）
        const currentDeadline = currentMonthFreezeDay.add(this.freezeDeadline, 'day');

        // 如果今天还没到本月的冻结截止日
        if (today.isBefore(currentDeadline)) {
          // 检查记录日期是否早于上月结算日
          const lastMonthFreezeDay = dayjs().subtract(1, 'month').startOf('day').date(this.freezeDay);
          if (date.isBefore(lastMonthFreezeDay) || date.isSame(lastMonthFreezeDay, 'day')) {
            return false;
          }
        } else {
          // 如果今天已经过了本月的冻结截止日
          // 检查记录日期是否早于本月结算日
          if (date.isBefore(currentMonthFreezeDay) || date.isSame(currentMonthFreezeDay, 'day')) {
            return false;
          }
        }

        return true;
      },

      addRecord (record) {
        // 检查是否在冻结期内
        if (!this.checkFreezePeriod(record.startTime)) {
          return;
        }

        const newRecord = {
          ...record,
          id: null,
          planVolume: 20,
          realVolume: 0,
          endTime: record.startTime,
          endVal: record.startVal,
          endReason: 1,
          curStatus: 1,
          consumerUserId: null,
          groupId: null,
          corpId: null,
          createBy: this.userInfo.username,
          createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          updateBy: this.userInfo.username,
          updateTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
        }
        if (record.prevRecord && record.prevRecord.startVal) {
          newRecord.startVal = record.prevRecord.endVal;
          newRecord.startTime = record.prevRecord.endTime;
          newRecord.realVolume = newRecord.endVal - newRecord.startVal;
        }
        this.$refs.modalForm.add(newRecord)
        this.$refs.modalForm.title = `补录加水量`
        this.$refs.modalForm.disableSubmit = false
      },
      editRecord (rec) {
        // 检查是否在冻结期内
        if (!this.checkFreezePeriod(rec.startTime)) {
          return;
        }

        const record = {
          ...rec,
          updateBy: this.userInfo.username,
          updateTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
        };
        const nextRecord = record.nextRecord;
        if (nextRecord) {
          record.endTime = nextRecord.startTime || record.endTime;
          record.endVal = nextRecord.startVal || record.endVal;
          if (record.endVal && record.startVal) {
            record.realVolume = record.endVal - record.startVal;
          }

        } else {
          record.endTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
        }

        if (!record.startVal && record.prevRecord && record.prevRecord.endVal) {
          record.startVal = record.prevRecord.endVal;
        }

        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = `修正加水量`
        this.$refs.modalForm.disableSubmit = false
      },
      getList () {
        if (validatenull(this.timeRange)) {
          this.queryParam.startTime_begin = null
          this.queryParam.startTime_end = null
        } else {
          this.queryParam.startTime_begin = this.timeRange[0] + ' 00:00:00'
          this.queryParam.startTime_end = this.timeRange[1] + ' 23:59:59'
        }
        this.searchQuery()
      },
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);

        console.log('loadData params:', params); // 添加日志以检查参数
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            // 获取原始数据
            const originalRecords = res.result.records || res.result

            // 处理异常数据
            this.dataSource = this.processDataAnomalies(originalRecords).map(record => ({
              ...record,
              isFrozen: !this.checkFreezePeriod(record.startTime)
            }))

            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      processDataAnomalies (records) {
        // 如果没有记录，直接返回空数组
        if (!records || records.length === 0) return records;

        // 创建记录的深拷贝，避免修改原始数据
        const processedRecords = JSON.parse(JSON.stringify(records));

        // 按devId分组并按时间排序
        const groupedRecords = processedRecords.reduce((acc, record) => {
          if (!acc[record.devId]) {
            acc[record.devId] = [];
          }
          acc[record.devId].push(record);
          return acc;
        }, {});

        // 遍历每个设备的记录组
        Object.keys(groupedRecords).forEach(devId => {
          const devRecords = groupedRecords[devId].sort((a, b) =>
            new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
          );

          // 从第二条记录开始检查
          for (let i = 0; i < devRecords.length; i++) {
            const prevRecord = devRecords[i - 1];
            const currentRecord = devRecords[i];
            const nextRecord = devRecords[i + 1];

            if (nextRecord) {
              currentRecord.nextRecord = { ...nextRecord };
            }
            if (!prevRecord) {
              continue;
            }
            // 防止prevRecord嵌套
            const prevRecordCopy = { ...prevRecord };
            delete prevRecordCopy.nextRecord;
            delete prevRecordCopy.prevRecord;

            currentRecord.prevRecord = prevRecordCopy;
            // 计算startVal和前一条记录endVal的差值
            const valueDifference = Math.abs(currentRecord.startVal - prevRecord.endVal);

            // 如果差值大于1，标记为异常
            if (valueDifference > 0.3) {
              currentRecord.isAnomalous = true;
              currentRecord.anomalyReason = `起码与前一条记录的止码相差 ${valueDifference.toFixed(3)}，可能存在丢失记录的情况`;
            }

            const sumRealVolume = currentRecord.realVolume + prevRecord.sumRealVolume;
            const calcSumRealVolume = currentRecord.endVal - prevRecord.startVal;
            if (prevRecord.consumerUserId === currentRecord.consumerUserId && prevRecord.devId === currentRecord.devId && prevRecord.startVal && currentRecord.endVal && Math.abs(sumRealVolume - calcSumRealVolume) > 0.5) {
              currentRecord.isAnomalous = true; // 标记为异常
              currentRecord.anomalyReason = `本条数据和前一条数据可能为重复数据`;
            }

            if (valueDifference > 0.5) {
              currentRecord.isAnomalous = true;
              currentRecord.anomalyReason = `起码与前一条记录的止码相差 ${valueDifference.toFixed(3)}，可能存在丢失记录的情况`;
            }
            if (currentRecord.realVolume > 30) {
              currentRecord.isAnomalous = true;
              currentRecord.anomalyReason = `实际取水量超过应用默认最大取水量30`;
            }

            const calcVolume = currentRecord.endVal - currentRecord.startVal;
            if (Math.abs(calcVolume - currentRecord.realVolume) > 0.5) {
              currentRecord.isAnomalous = true;
              currentRecord.anomalyReason = `表底值之差(${calcVolume})和实际取水量(${currentRecord.realVolume})误差(${Math.abs(calcVolume - currentRecord.realVolume)})超过0.5`;
            }
          }
        });

        // 将处理后的记录展平，保持原始顺序
        return processedRecords;
      },
      corpChange () {
        this.queryParam.groupId = null;
        this.queryParam.consumerUserId = null;
        this.searchQuery();
        this.getConsGroup();
        this.getConsUser();
      },
      groupChange () {
        this.queryParam.consumerUserId = null;
        this.searchQuery();
        this.getConsUser();
      },
      getConsGroup () {
        if (!this.userInfo.thirdAccount) {
          return;
        }
        this.consGroupOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          column: 'groupName',
          order: 'asc',
        };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.consGroupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getConsUser () {
        // if (!this.userInfo.thirdAccount) {
        //   return;
        // }
        this.consUserOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          groupId: this.queryParam.groupId,
          column: 'username',
          order: 'asc',
        };
        getAction(this.url.corpUserList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(user => {
              this.consUserOptions.push({
                value: user.id,
                text: user.nickname
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getDevList () {
        getAction(this.url.corpDevList, { pageSize: 999999 }).then((res) => {
          if (res.success) {
            res.result.records.forEach(device => {
              this.devOptions.push({
                value: device.id,
                text: device.devName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getFeezeConfig () {
        getAction(this.url.categoryList, {
          cusProp1: 'FREEZE_DAY,FREEZE_DEADLINE'
        }).then(res => {
          if (res.result.records && res.result.records.length > 0) {
            // 查找并设置冻结修改期限
            const deadlineRecord = res.result.records.find(item =>
              item.cusProp1 && item.cusProp1.toUpperCase() === 'FREEZE_DEADLINE'
            );
            if (deadlineRecord) {
              this.freezeDeadline = parseInt(deadlineRecord.cusProp2) || -1;
            }

            // 查找并设置月报冻结日
            const freezeDayRecord = res.result.records.find(item =>
              item.cusProp1 && item.cusProp1.toUpperCase() === 'FREEZE_DAY'
            );
            if (freezeDayRecord) {
              this.freezeDay = parseInt(freezeDayRecord.cusProp2) || 1;
            }
          }
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'orderNo', text: '订单号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备', dictCode: '`iwt-wf`.dev_list,dev_name,id' })
        fieldList.push({ type: 'string', value: 'consumerUserId', text: '取水人', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'planVolume', text: '计划取水量', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'realVolume', text: '实际取水量', dictCode: '' })
        fieldList.push({ type: 'int', value: 'curStatus', text: '当前状态', dictCode: '' })
        fieldList.push({ type: 'date', value: 'startTime', text: '开始时间' })
        fieldList.push({ type: 'date', value: 'endTime', text: '结束时间' })
        fieldList.push({ type: 'string', value: 'endReason', text: '结束原因', dictCode: '' })
        fieldList.push({ type: 'int', value: 'usedMinutes', text: '加水时长(分钟)', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'realFlowrate', text: '实际流速(m³/h)', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped lang="less">
  @import '~@assets/less/common.less';
</style>